// extracted by mini-css-extract-plugin
export default {"failure":"failure_failure__bOleu","failWarnIcon":"failure_failWarnIcon__a5Wix","text":"failure_text__4dY6B","rotate":"failure_rotate__m+Ho4"};